'use client';

import { StepWrapper } from './Step.styles';
import Steps from './Steps';

export default function StepsSection() {
  return (
    <StepWrapper>
      <Steps />
    </StepWrapper>
  );
}
